import { inject, NewInstance, BindingEngine } from 'aurelia-framework';
import { BillOfMaterialService } from 'pages/quote-setup/bill-of-material/service';
import { PartService } from 'pages/quote-setup/parts/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController, DialogService } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), BillOfMaterialService, EventAggregator, PartService, DialogService, BindingEngine)
export class StatusEditor {
    constructor(controller, validationController, billOfMaterialService, ea, partService, dialogService, bindingEngine) {
        this.controller = controller;
        this.dialogService = dialogService;
        this.billOfMaterialService = billOfMaterialService;
        this.partService = partService;
        this.ea = ea;
        this.childPart = {
            partId: null
        };

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('partId').required().withMessage('Part is required')
            .ensure('quantity').required().withMessage('Quantity is required')
            .rules;

        bindingEngine
            .propertyObserver(this.childPart, 'partId')
            .subscribe(async (newValue, oldValue) => {
                if (newValue != null) {
                    this.part = await this.partService.getById(newValue);
                } else {
                    this.part = null;
                }
            });
    }

    async activate(model) {
        if (model?.id != null) {
            this.childPart = await this.billOfMaterialService.getById(model.parentPartId, model.id);
            this.part = await this.partService.getById(this.childPart.partId);
        }

        if (model?.parentPartId != null) {
            this.childPart.parentPartId = model.parentPartId;
        }
    }

    attached() {
        this.uxBody.querySelector('input').focus();
    }

    addPart() {
        this.dialogService.open({ viewModel: this.partService.editor });
    }

    addMachine() {
        this.dialogService.open({ viewModel: this.machineService.editor });
    }

    addPurchasePartType() {
        this.dialogService.open({ viewModel: this.purchasePartTypeService.editor });
    }

    async save(addNew) {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.childPart.id) {
                    await this.billOfMaterialService.update(this.childPart.parentPartId, this.childPart);
                    toastr.success('Child part was updated!');
                } else {
                    await this.billOfMaterialService.create(this.childPart.parentPartId, this.childPart);
                    toastr.success('New child part was added!');
                }
                this.ea.publish('bill-of-material:updated', this.childPart);
                if (addNew) {
                    this.partSelect.clearSelection();
                    this.ea.publish(`bom-part-${this.childPart.parentPartId}`);
                    this.uxBody.querySelector('input').focus();
                } else {
                    this.controller.ok(this.childPart);
                }
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }

}
